import { Alert, Button } from "react-bootstrap";

import { useEffect, useState } from "react";
// import FileError from "../../../components/Icons/ErrorFile";
import { Modal } from "../../../../../components";
import { useGeneralAppStore } from "../../../../../store/generalAppStore";
import CalendarioSemanal from "../CalendarioSemanal";

const ModalInteraccionesDias = ({ mes, interacciones, nombreMes, nombreAgente }) => {

    //? ESTADOS GLOBALES

    const { modals, handlerModal } = useGeneralAppStore();

    useEffect(() => {
        return () => {
            handlerModal({ modal: false, modalName: "interacciones_dia" })
        }
    }, [])

    console.log(Object?.keys(interacciones)?.sort((a, b) => Number(a) - Number(b)))

    console.log(interacciones)

    return (
        <>
            <Modal
                show={modals.includes('interacciones_dia')}
                size={"xl"}
                onHide={() => handlerModal({ modal: false, modalName: "interacciones_dia" })}
                title={() => "Interacciones" + nombreAgente}
            >
                <div className="bg-secondary text-center font-bold text-white d-flex align-items-center" style={{height:"34px"}}>{nombreMes}</div>
            <CalendarioSemanal mes={mes} interacciones={Object?.keys(interacciones)?.sort((a, b) => Number(a) - Number(b)).map(key => ({ dia: key, ...interacciones[key] }))} nombreMes={nombreMes} />
            {/* <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
                    {
                        Object?.keys(interacciones)?.sort((a, b) => Number(a) - Number(b))?.map((key, index) => {
                            const diaData = interacciones[key];
                            return (
                                <div key={index} className="p-2 border rounded col"
                                    style={{ flex: "0 0 calc(100% / 7)" }}
                                >
                                    <div className=" ">
                                        {diaData?.nombre}
                                    </div>

                                </div>
                            )
                        })
                    }
                </div> */}

        </Modal >
        </>
    );
}
export default ModalInteraccionesDias;